// biome-ignore lint/style/noRestrictedImports: encapsulation
import { secondsInMinute } from "date-fns";

import { floor } from "~/tools/floor";

export const nanosecondsInMicrosecond = 1e3;
export const nanosecondsInMillisecond = 1e6;
export const nanosecondsInSecond = 1e9;
export const nanosecondsInMinute = nanosecondsInSecond * secondsInMinute;

export function nanosecondsToMicroseconds(ns: number): number {
	return floor(ns / nanosecondsInMicrosecond, 0);
}

export function nanosecondsToMilliseconds(ns: number): number {
	return floor(ns / nanosecondsInMillisecond, 0);
}

export function nanosecondsToSeconds(ns: number): number {
	return floor(ns / nanosecondsInSecond, 0);
}

export function nanosecondsToMinutes(ns: number): number {
	return floor(ns / nanosecondsInMinute, 0);
}

export function microsecondsToNanoseconds(us: number): number {
	return us * nanosecondsInMicrosecond;
}

export function millisecondsToNanoseconds(ms: number): number {
	return ms * nanosecondsInMillisecond;
}

export function secondsToNanoseconds(s: number): number {
	return s * nanosecondsInSecond;
}

export function minutesToNanoseconds(m: number): number {
	return m * nanosecondsInMinute;
}
